import { makeStyles } from '@material-ui/core/styles';
const WHITE = '#FFFFFF';
const supplementGreen = '#3A9891';
const dimmedGreen = '#79D5CE';
const FONT_WEIGHT_LITE = 300;
const FONT_WEIGHT_BOLD = 400;
const PADDING = '20px';
export const useStyles = makeStyles({
    parent: {
        backgroundColor: supplementGreen,
        marginBottom: '30px',
    },

    upperWrapper: {
        margin: '0 !important',
    },

    textbox: {
        color: WHITE,
        flexBasis: '78%',
        flexGrow: 0,
        padding: PADDING,
        '& > .header': {
            fontSize: '20px',
            fontWeight: FONT_WEIGHT_BOLD,
            lineHeight: '24px',
            paddingRight: PADDING,
        },
        '& > .text': {
            fontSize: '16px',
            fontWeight: FONT_WEIGHT_LITE,
            lineHeight: '20px',
        },
        '& > .details': {
            color: dimmedGreen,
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: FONT_WEIGHT_LITE,
            lineHeight: '20px',
            paddingRight: PADDING,
        },
    },
});
